
    import { mapActions } from 'vuex';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import {
        faSparkles as fasSparkles,
    } from '@fortawesome/pro-solid-svg-icons/faSparkles';
    import {
        faPersonArrowUpFromLine as fasPersonArrowUpFromLine,
    } from '@fortawesome/pro-solid-svg-icons/faPersonArrowUpFromLine';

    import {
        faChevronLeft as farChevronLeft,
    } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
    import {
        faChevronRight as farChevronRight,
    } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
    import { shuffleList } from '@/utils/helpers';

    export default {
        components: {
            EducationModal: () => process.client ? import('@/components/Education/EducationModal') : {},
            FontAwesomeIcon,
        },

        props: {
            articlePayload: {
                type: Object,
                default: () => ({}),
            },
        },

        data() {
            return {
                articles: [],
                selectedArticle: {},
                educationLevel: [],
                availability: [],
                icons: {
                    fasSparkles,
                    farChevronLeft,
                    farChevronRight,
                    fasPersonArrowUpFromLine,
                },
            };
        },

        computed: {
            isModalOpen() {
                return !!Object.entries(this.selectedArticle).length;
            },
        },

        created() {
            if (this.$hideEducation !== 'Yes') {
                this.getEducationArticles();
            }
        },

        methods: {
            ...mapActions('education', {
                $_getEducationArticles: 'getEducationArticles',
            }),

            ...mapActions('attribute', {
                $_getEducationLevel: 'getEducationLevel',
                $_getAvailability: 'getAvailability',
            }),

            getEducationArticles() {
                this.$_getEducationArticles(this.articlePayload).then((response) => {
                    this.articles = response.data || [];

                    if (this.articles.length) {
                        this.articles = shuffleList(this.articles);
                        this.afterGetEducationArticles();
                    } else {
                        this.$emit('destroy');
                    }
                });
            },

            getEducationLevel() {
                this.$_getEducationLevel().then((response) => {
                    this.educationLevel = response.data;
                });
            },

            getAvailability() {
                this.$_getAvailability().then((response) => {
                    this.availability = response.data;
                });
            },

            onSelectArticle(article) {
                this.selectedArticle = article;
                if (this.educationLevel.length === 0) {
                    this.getEducationLevel();
                    this.getAvailability();
                }
            },

            clearSelectedArticle() {
                this.selectedArticle = {};
            },

            afterGetEducationArticles() { },
        },
    };
